import { CleanSearchTableState } from './actions/cleanSearchTableState';
import { LoadSearchTableState } from './actions/loadSearchTable';
import { ActionDatapoint } from 'owa-analytics';
import { PerformanceDatapoint } from 'owa-analytics';
import { LazyAction, LazyModule, LazyImport } from 'owa-bundling';
import { TableView } from 'owa-mail-list-store';
import ExecuteSearchResponseMessage from 'owa-service/lib/contract/ExecuteSearchResponseMessage';
import { OnInitialTableLoadComplete } from 'owa-mail-loading-action-types';

const lazyModule = new LazyModule(() =>
    import(/* webpackChunkName: "SearchActions" */ './lazyIndex')
);

export let lazyLoadSearchTable = new LazyAction(lazyModule, m => m.loadSearchTable);

export let lazyCleanSearchTableState = new LazyAction(lazyModule, m => m.cleanSearchTableState)
    .importAndExecute;

export let lazyLoadMoreFindItemSearch = new LazyImport(lazyModule, m => m.loadMoreFindItemSearch);

export {
    CleanSearchTableState,
    ExecuteSearchResponseMessage,
    LoadSearchTableState,
    TableView,
    ActionDatapoint,
    PerformanceDatapoint,
    OnInitialTableLoadComplete,
};
